<template>
  <div class="col-12">
    <div class="input-group mb-3">
      <input aria-describedby="basic-addon1" aria-label=""
             class="form-control col-form-label-lg"
             name="search" placeholder="Rechercher" type="text" v-model="query" v-on:input="search(false)">
      <div class="input-group-append">
        <button class="btn btn-primary" dusk="search_button" type="button" v-on:click="search(false)">{{ $t('search') }}
        </button>
      </div>
    </div>
    <small class="form-text text-muted">
      <i v-if="loading" class='fas fa-circle-notch fa-spin'></i> <span
        v-if="!loading">{{
        $t('number_of_result', {
          number: (response['total'] > 0) ? '1 - ' + response['to'] +
              '(total: ' + response['total'] + ')' : '0'
        })
      }}
    </span>
    </small>
    <div class="row mt-5">
      <div class="col-12 col-md-2">
        <h6 class="mt-3">{{ $t('equipment_type') }}</h6>
        <div class="form-check custom-checkbox custom-control" v-for="(badge, index) in equipments">
          <input :disabled="loading" class="custom-control-input" type="checkbox"
                 v-bind:checked="!badge['disabled']" v-bind:id="'t' + index" v-bind:name="badge['id']"
                 v-on:click="inverseBadge(index, equipments)">
          <label class="custom-control-label" v-bind:for="'t' + index">
            {{ badge['name'] }}
          </label>
        </div>
        <div>
          <h6 class="mt-3">{{ $t('os') }}</h6>

          <div class="form-check custom-checkbox custom-control" v-for="(badge, index) in os">
            <input :disabled="loading" class="custom-control-input" type="checkbox"
                   v-bind:checked="!badge['disabled']" v-bind:id="'c' + index" v-bind:name="badge['name']"
                   v-on:click="inverseBadge(index, os)"/>
            <label class="custom-control-label" v-bind:for="'c' + index">
              {{ badge['name'] }}
            </label>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-10">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
            <tr>
              <th v-for="(column, index) in columns" v-on:click="sortBy(index)">
                <span style="cursor: pointer;">{{ column['name'] }}</span>
                <span v-if="column['orderable']">
                            <i class="fas fa-arrow-down fa-sm"
                               v-bind:class="{'text-danger': sortCell === index && column['sortDirection'] === 1}"></i>
                            <i class="fas fa-arrow-up fa-sm"
                               v-bind:class="{'text-danger': sortCell === index && column['sortDirection'] === -1}"></i>

                        </span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="loading && page === 1">
              <td colspan="7"><i class="fas fa-circle-notch fa-spin"></i>{{ $t('data_loading') }}
              </td>
            </tr>
            <tr v-if="data.length === 0 && loading === false">
              <td colspan="7">{{ $t('no_result_found') }}</td>
            </tr>
            <tr v-for="entry in filteredResults" v-if="!loading || page > 1">
              <th scope="row">{{ entry['id'] }}</th>
              <td>{{ entry['denomination'] }}</td>
              <td>{{ entry['location'] }}</td>
              <td><i class="fas fa-arrows-alt-h"></i> {{ entry['width'] }}m ({{ entry['resolution_width'] }}px)
                <i class="fas fa-arrows-alt-v"></i> {{ entry['height'] }}m ({{ entry['resolution_height'] }}px)
              </td>
              <td><span
                  v-if="entry['last_seen_at'] != null">{{ entry['last_seen_at'] | moment('DD/MM/YYYY HH:mm') }}</span><span
                  v-else>Jamais</span></td>
              <td><a v-bind:href="'equipments/' + entry['id']">{{ $t('details') }}</a></td>
            </tr>
            <tr v-if="!loading && data.length !== 0 && response['last_page'] > page">
              <td id="loadMore" colspan="6" v-on:click="loadMore">{{ $t('load_more') }}</td>
            </tr>
            <tr v-if="loading && data.length !== 0 && response['last_page'] > page">
              <td colspan="6"><i class="fas fa-circle-notch fa-spin"></i>
                {{ $t('next_results_loading') }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['_os'],
  data: function () {
    return {
      page: 1,
      response: [],
      sortCell: '',
      loading: true,
      query: '',
      data: [],
      equipments: [],
      os: [],
      columns: {
        'id': {
          name: this.$i18n.t('id'),
          db_name: 'id',
          orderable: true,
          sortDirection: 1,
          type: 'number'
        },
        'denomination': {
          name: this.$i18n.t('name'),
          db_name: 'denomination',
          orderable: true,
          sortDirection: 1,
          type: 'true'
        },
        'address': {
          name: this.$i18n.t('address'),
          db_name: 'address',
          orderable: true,
          sortDirection: 1,
          type: 'text'
        },
        'dimensions': {
          name: this.$i18n.t('dimensions'),
          db_name: '',
          orderable: false,
          sortDirection: 0,
          type: 'text'
        },
        'last_seen_at': {
          name: this.$i18n.t('last_seen'),
          db_name: 'last_seen_at',
          orderable: true,
          sortDirection: 1,
          type: 'date'
        },
        'details': {
          name: this.$i18n.t('details'),
          db_name: '',
          orderable: false,
          sortDirection: 1,
          type: ''
        },
      },
    }
  },
  computed: {
    filteredResults: function () {
      var data = this.data;
      if (this.sortCell) {
        var cell = this.columns[this.sortCell];
        var direction = cell['sortDirection'];
        if (cell['type'] === 'date') {
          data = data.slice().sort(function (a, b) {
            var a1 = new Date(a[cell['db_name']]);
            var b1 = new Date(b[cell['db_name']]);

            return (a1.getTime() === b1.getTime()) ? 0 : ((a1.getTime() > b1.getTime()) ? 1 : -1) * cell['sortDirection'];
          });
        } else if (cell['type'] === 'number') {
          data = data.slice().sort(function (a, b) {
            var a1 = a[cell['db_name']];
            var b1 = b[cell['db_name']];

            return (a1 === b1) ? 0 : ((a1 > b1) ? 1 : -1) * cell['sortDirection'];
          });
        } else if (cell['type'] === 'text') {
          data = data.slice().sort(function (a, b) {
            var a1 = a[cell['db_name']];
            var b1 = b[cell['db_name']];

            return (a1 === b1) ? 0 : ((a1 > b1) ? 1 : -1) * cell['sortDirection'];
          });
        }
      }
      return data;
    },
  },
  created: function () {
    this.os = this._os;
    this.os.forEach(function (item) {
      item['disabled'] = false;
    }.bind(this));
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted: function () {
    axios.post('equipments/available', {})
        .then(response => {
          this.equipments = response.data;
          this.equipments.forEach(function (item) {
            item['disabled'] = false;
          }.bind(this));
          this.search();
        });


  },
  methods: {
    handleScroll: function () {
      if (!this.loading) {
        if (document.getElementById('loadMore') != null && this.isInViewport(document.getElementById('loadMore'))) {
          this.loadMore();
        }
      }
    },
    isInViewport: function (elem) {
      var bounding = elem.getBoundingClientRect();
      return (
          bounding.top >= 0 &&
          bounding.left >= 0 &&
          bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    sortBy: function (index) {
      if (this.columns[index]['orderable'] === true) {
        this.sortCell = index;
        this.columns[index]['sortDirection'] *= -1;
      }
    },
    inverseBadge: function (index, arr) {
      arr[index]['disabled'] = !arr[index]['disabled'];
      this.$forceUpdate();
      this.search();
    },
    loadMore: function () {
      this.page++;
      this.search(true);
    },
    search: function (next_page = false) {
      this.loading = true;
      if (!next_page) {
        this.page = 1;
        this.data = [];
      }
      var equipments_id = [];
      this.equipments.forEach(function (item) {
        if (!item['disabled']) {
          equipments_id.push(item['id']);
        }
      });
      var os_value = [];
      this.os.forEach(function (item) {
        if (!item['disabled']) {
          os_value.push(item['value']);
        }
      });
      axios
          .post('equipments/search', {
            query: this.query,
            equipments: equipments_id,
            os: os_value,
            page: this.page,
          })
          .then(response => {
            if (next_page) {
              this.data = this.data.concat(response.data.data);
            } else {
              this.data = response.data.data;
            }
            this.response = response.data;
            this.loading = false;
          });

    },
  }
}
</script>
